import Vue from "vue";
import App from "./App.vue";
import store from "./store/store";
import i18n from "./plugins/i18n";
import axios from "axios";
import Popover from "vue-js-popover";
import "leaflet/dist/leaflet.css";

Vue.use(Popover);

/*
 * Obtenir le code du pays en fonction de la culture.
 * C'est un simple split qui s'appuie sur la règle suivante:
 * - si la culture est xx-YY => retourner YY
 * - si la culture est xx => retourner XX
 * xx et yy doivent avec deux caractères.
 * S'il y a une erreur, on retourne null.
 */
function CountryCodeFromCulture(culture) {
  let currentCulture = null;
  try {
    let s = culture.split("-");
    if (s.length >= 1 && s.length <= 2) {
      if (s.length == 1) {
        if (s[0].length == 2) {
          currentCulture = s[0];
        }
      } else {
        if (s[1].length == 2) {
          currentCulture = s[1];
        }
      }
    }
    return currentCulture.toLocaleUpperCase();
  } catch {
    //noop
  }
  return currentCulture;
}

// params
const DEFAULT_CULTURE = "en-US";

let element = document.getElementById("parcelshop-picker");
let postcode = "";
let city = "";
let countryCode = "";
let printInStore = false;
let showFilterPrintInStore = false;
let isPrintInStoreHighlighted = false;
let showFilterLocker = false;
let isLockerHighlighted = false;
let authorizedNatures = "";
let culture = null;
let selectionMode = false;
let priceMode = false;
let avoidSaturated = false;
let parcelshopNatureAllowed = "";
let parcelshopAgenceAllowed = "";
let enableUnavailability = false;
let token = null;
let theme = null;
let typeLivraisonFilter = '';

if (element) {
  postcode = element.getAttribute("postcode");
  city = element.getAttribute("city");
  countryCode = element.getAttribute("country-code");
  printInStore = element.getAttribute("print-in-store") === "true";
  showFilterPrintInStore = element.getAttribute("showFilterPrintInStore") === "true";
  showFilterLocker = element.getAttribute("showFilterLocker") === "true";
  isPrintInStoreHighlighted = element.getAttribute("isPrintInStoreHighlighted") === "true";
  isLockerHighlighted = element.getAttribute("isLockerHighlighted") === "true";
  authorizedNatures = element.getAttribute("authorized-natures") ?? "";
  culture = element.getAttribute("culture");
  selectionMode = element.getAttribute("enable-selection") === "true";
  priceMode = element.getAttribute("enable-pricing") === "true";
  avoidSaturated = element.getAttribute("avoidSaturated");
  parcelshopNatureAllowed = element.getAttribute("parcelshopNatureAllowed");
  parcelshopAgenceAllowed = element.getAttribute("parcelshopAgenceAllowed");
  enableUnavailability =
    element.getAttribute("enable-unavailability") === "true";
  token = element.getAttribute("token");
  theme = element.getAttribute("theme");
  typeLivraisonFilter = element.getAttribute("default-livraison-type-filter");


  store.commit(
    "setIsCompleterDonnees",
    element.getAttribute("is-completer-donnees") != null &&
      element.getAttribute("is-completer-donnees") === "true"
      ? true
      : false
  );

  // session x token
  if (token) {
    axios.defaults.headers.common["RequestVerificationToken"] = token;
  }
}

// culture x language
if (!culture) {
  if (navigator.language) {
    culture = navigator.language;
  } else {
    culture = DEFAULT_CULTURE;
  }
}

if (!countryCode && culture) {
  countryCode = CountryCodeFromCulture(culture);
}

i18n.locale = culture.split("-")[0] || "en";
axios.defaults.headers.common["Accept-Language"] = culture;

store.state.enableUnavailability = enableUnavailability;

if (theme == "js-findTheme") {
  theme = document.querySelector("#pspTheme").value;
}
const styleElement = document.createElement("link");
styleElement.setAttribute("rel", "stylesheet");
styleElement.setAttribute("type", "text/css");

if (theme == "inpost") {
  styleElement.setAttribute(
    "href",
    `/Scripts/vue/parcelshop-picker/css/styleINPOST.css`
  );
} else if (theme != null) {
  styleElement.setAttribute(
    "href",
    `/Scripts/vue/parcelshop-picker/css/styleMR.css`
  );
}
document.getElementsByTagName("head")[0].appendChild(styleElement);

if (theme == "inpost") {
  store.state.theme = "inpost";
} else {
  store.state.theme = "mr";
}

// session x token
if (token) {
  axios.defaults.headers.common["RequestVerificationToken"] = token;

}

// render
new Vue({
  store,
  i18n,
  render: (h) =>
    h(App, {
      props: {
        postcode: postcode,
        town: city,
        countryCode: countryCode,
        printInStore: printInStore,
        showFilterPrintInStore: showFilterPrintInStore,
        showFilterLocker: showFilterLocker,
        isPrintInStoreHighlighted : isPrintInStoreHighlighted,
        isLockerHighlighted: isLockerHighlighted,
        authorizedNatures: authorizedNatures,
        selectionMode: selectionMode,
        priceMode: priceMode,
        avoidSaturated: avoidSaturated,
        parcelshopNatureAllowed: parcelshopNatureAllowed,
        parcelshopAgenceAllowed: parcelshopAgenceAllowed,
        enableUnavailability: enableUnavailability,
        typeLivraisonFilter: typeLivraisonFilter
      },
    }),
}).$mount("#parcelshop-picker");
